import axios from "axios";
import config from "../../config";

const baseUrl = `${config.baseUrl}/api/estados-participante`;

export async function getEstadosParticipante() {
  try {
    const response = await axios.get(baseUrl);
    return response.data;
  } catch (error) {
    console.error("Error fetching estados participante:", error);
    throw error;
  }
}

export async function getEstadoParticipanteById(id) {
  try {
    const response = await axios.get(`${baseUrl}/${id}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching estado participante ${id}:`, error);
    throw error;
  }
}

export async function getEstadoParticipanteByCodigo(codigo) {
  try {
    const response = await axios.get(`${baseUrl}/codigo/${codigo}`);
    return response.data;
  } catch (error) {
    console.error(`Error fetching estado participante ${codigo}:`, error);
    throw error;
  }
}